// Filtros de eventos para Sentry (beforeSend). Puros, sin Vue ni store.
//
// El interceptor de src/api/api.js ya maneja la sesión vencida: refresh
// single-flight + redirect a "/go-to-plan" o "/", y rechaza hacia el caller
// para que corran sus finally. Los callers no hacen catch de ese rechazo, así
// que llegaba a window.onunhandledrejection y Sentry lo reportaba como error
// (CFO_REMOTO_FRONTEND-9P/9Q, 54 usuarios) aunque el usuario ya estaba siendo
// redirigido. Un 400 sí pasa: es una validación del backend que el caller
// debería manejar.
import axios from "axios";

const AUTH_STATUSES = [401, 403];

export function isExpectedApiRejection(error) {
	if (!error) return false;
	// Cancelación propia del interceptor de request (token vencido/ilegible).
	if (axios.isCancel(error)) return true;
	return (
		axios.isAxiosError(error) &&
		AUTH_STATUSES.includes(error.response?.status)
	);
}

// Tags para que un rechazo de axios sea accionable en Sentry: el evento de un
// timeout ("timeout of 30000ms exceeded", CFO_REMOTO_FRONTEND-9R) llegaba sin
// decir qué endpoint lo produjo. Se leen del error, sin tocar el scope global.
export function apiRequestTags(error) {
	if (!axios.isAxiosError(error)) return null;
	const config = error.config || {};
	const tags = {
		"api.method": (config.method || "").toUpperCase(),
		"api.url": config.url || "",
		"api.status": error.response?.status != null ? String(error.response.status) : "",
		"api.code": error.code || "",
	};
	return Object.fromEntries(Object.entries(tags).filter(([, value]) => value !== ""));
}

// Firma de Sentry: (event, hint) → event | null. null descarta el evento.
export function sentryBeforeSend(event, hint) {
	const error = hint?.originalException;
	if (isExpectedApiRejection(error)) return null;
	const tags = apiRequestTags(error);
	if (tags && Object.keys(tags).length) {
		event.tags = { ...(event.tags || {}), ...tags };
	}
	return event;
}
